// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-api-template-tsx": () => import("./../../../src/templates/APITemplate.tsx" /* webpackChunkName: "component---src-templates-api-template-tsx" */),
  "component---src-templates-component-template-tsx": () => import("./../../../src/templates/ComponentTemplate.tsx" /* webpackChunkName: "component---src-templates-component-template-tsx" */),
  "component---src-templates-icon-template-tsx": () => import("./../../../src/templates/IconTemplate.tsx" /* webpackChunkName: "component---src-templates-icon-template-tsx" */)
}

